import React from 'react';
import SEO from '../SEO';
import { getFullUrl } from '../../utils/url';

// Mise en page commune aux pages légales (Mentions légales, Politique de confidentialité).
// `sections` = [{ heading, blocks: [{ type: 'p'|'list', content: string | string[] }] }]
export const LegalPage = ({ title, intro, seoDescription, path, sections }) => (
  <div className="min-h-screen bg-cream">
    <SEO
      title={`${title} - MMD CONSEIL`}
      description={seoDescription}
      url={getFullUrl(path)}
    />

    {/* Hero */}
    <section className="bg-primary-blue text-white pt-32 md:pt-40 pb-14 md:pb-20">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <p className="text-xs uppercase tracking-[0.25em] font-semibold text-warm-accent mb-4">MMD CONSEIL</p>
        <h1 className="font-heading text-4xl md:text-6xl font-light tracking-tight">{title}</h1>
        {intro && <p className="text-white/70 mt-6 max-w-2xl leading-relaxed">{intro}</p>}
      </div>
    </section>

    {/* Contenu */}
    <section className="section-spacing">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        {sections.map((section) => (
          <div key={section.heading} className="mb-10" data-testid={`legal-section-${section.heading.split('.')[0].trim()}`}>
            <h2 className="font-heading text-xl md:text-2xl font-medium text-primary-blue mb-4">
              {section.heading}
            </h2>
            {section.blocks.map((block, j) =>
              block.type === 'list' ? (
                <ul key={`${section.heading}-${j}`} className="list-disc pl-6 space-y-2 text-text-gray mb-5">
                  {block.content.map((item, k) => (
                    <li key={`${j}-${k}`} className="leading-relaxed">{item}</li>
                  ))}
                </ul>
              ) : (
                <p key={`${section.heading}-${j}`} className="text-text-gray leading-relaxed mb-4 whitespace-pre-line">
                  {block.content}
                </p>
              )
            )}
          </div>
        ))}
      </div>
    </section>
  </div>
);
